import * as actionTypes from './actionTypes';

export const setOtpEnabled = (otpEnabled) => ({
  type: actionTypes.OTP_ENABLED,
  otpEnabled,
});